module.exports = __webpack_public_path__ + "img/image1.8a19989b.png";